export const isSidebarItemVisible = (
  menuItem,
  {
    accountId,
    globalConfig = {},
    isEnterprise = false,
    isFeatureEnabledonAccount,
    isNewFeatureFlagEnabled,
  } = {}
) => {
  if (menuItem.globalConfigFlag) {
    return !!globalConfig[menuItem.globalConfigFlag];
  }

  const isFeatureEnabled = menuItem.featureFlag
    ? !!isFeatureEnabledonAccount(accountId, menuItem.featureFlag)
    : true;

  if (menuItem.newFeatureFlag) {
    const isEnabled = !!isNewFeatureFlagEnabled(menuItem.newFeatureFlag);
    return menuItem.hideIfFeatureFlag ? !isEnabled : isEnabled;
  }

  if (menuItem.isEnterpriseOnly) {
    return isEnterprise && (isFeatureEnabled || !!globalConfig.displayManifest);
  }

  return isFeatureEnabled;
};

export const withSectionTitles = (menuItems, isVisible) => {
  let openSection;
  return menuItems.map(menuItem => {
    if (!isVisible(menuItem)) return menuItem;
    if (menuItem.section === openSection) return menuItem;
    openSection = menuItem.section;
    if (!menuItem.section) return menuItem;
    return { ...menuItem, sectionTitle: menuItem.section };
  });
};
